import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ZipFileComponent } from './zip-file.component';

export const zipFileRoutes: Routes = [
  {
    path: 'zip-file',
    component: ZipFileComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(zipFileRoutes)],
  exports: [RouterModule]
})
export class ZipFileRoutingModule {}



// WEBPACK FOOTER //
// /opt/app/src/app/features/zip-file/zip-file-routing.module.ts